import { Module } from 'vuex';
import { Nullable, RootState } from 'frontend/types';

export interface XPPerDifficultyConfig {
  hard: number;
  basic: number;
}

interface XPPerSolvableConfigState {
  xp_per_solvable_active_for_user: boolean;
  can_earn_per_solvable_xp: boolean;
  xp_per_difficulty: Nullable<XPPerDifficultyConfig>;
}

const xpPerSolvableConfig: Module<XPPerSolvableConfigState, RootState> = {
  namespaced: true,
  state: {
    xp_per_solvable_active_for_user: false,
    can_earn_per_solvable_xp: false,
    xp_per_difficulty: null,
  },
  getters: {
    isXPPerSolvableEnabled: (state: XPPerSolvableConfigState): boolean =>
      state.xp_per_solvable_active_for_user,
    canEarnPerSolvableXP: (state: XPPerSolvableConfigState): boolean =>
      state.can_earn_per_solvable_xp,
    xpPerDifficulty: (state: XPPerSolvableConfigState): Nullable<XPPerDifficultyConfig> =>
      state.xp_per_difficulty,
  },
  mutations: {
    setValue(state: XPPerSolvableConfigState, value: XPPerSolvableConfigState): void {
      Object.assign(state, value);
    },
  },
};

export default xpPerSolvableConfig;
